import styled from "../Themes";

export const CopyCell = styled(`div`)`
  cursor: pointer;
`;
